module.exports = __webpack_public_path__ + "assets/img/102b8ef4a255d76614846faad34fef23.png";